import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';

const Footer = styled(MuiAppBar)(({ theme }) => ({
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    boxShadow: 'none',
    width: '100%',
    position: 'static',
}));

export default Footer;
